import { FieldNames } from '@fs/identity.js'

export default {
  ...FieldNames,
  USERNAME: 'username',
  CURRENT_PASSWORD: 'password',
  CITIZEN: 'citizen',
  VERIFICATION_CODE: 'code',
}
